<mat-card class="reportsCard">
  <div class="reportsHeader">
    <div>
      <div class="reportsEyebrow">Отчёты клиента</div>
      <div class="reportsSubtitle">Продажи и возвраты · текущий месяц неполный · суммы в гривнах</div>
    </div>
    <div class="reportControls">
      <mat-button-toggle-group [value]="monthsCount" (change)="setPeriod($event.value)" aria-label="Период отчёта">
        <mat-button-toggle [value]="3">3 мес.</mat-button-toggle>
        <mat-button-toggle [value]="6">6 мес.</mat-button-toggle>
        <mat-button-toggle [value]="12">12 мес.</mat-button-toggle>
      </mat-button-toggle-group>
      <button mat-icon-button (click)="reload()" [disabled]="loading" aria-label="Обновить отчёт" matTooltip="Обновить отчёт"><mat-icon>refresh</mat-icon></button>
    </div>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <div class="reportsBody" *ngIf="!loading && report; else reportsState">
    <div class="dataWarning" *ngIf="report.incomplete_cost_data" role="status">
      <mat-icon>info_outline</mat-icon>
      Часть продаж или возвратов не включена в прибыль и оборот: себестоимость ещё не подтверждена.
    </div>
    <div class="periodNote" *ngIf="report.period">{{ report.period.date_from | date: 'dd.MM.yyyy' }} — {{ report.period.date_to | date: 'dd.MM.yyyy' }} · средние показатели за {{ monthsCount }} мес. · долги и предоплата на сегодня</div>
    <div class="summaryGrid">
      <article class="summaryCard">
        <div class="summaryLabel">Средняя наценка</div>
        <div
          class="summaryValue"
          [ngClass]="summary.avg_markup_percent >= 0 ? 'value-positive' : 'value-negative'"
        >
          {{ summary.avg_markup_percent | number: '1.0-2' }}%
        </div>
      </article>

      <article class="summaryCard">
        <div class="summaryLabel">Среднее кол-во заказов в месяц</div>
        <div class="summaryValue value-neutral">
          {{ summary.avg_orders_per_month | number: '1.0-2' }}
        </div>
      </article>

      <article class="summaryCard">
        <div class="summaryLabel">Средняя прибыль за месяц</div>
        <div class="summaryValue" [ngClass]="summary.avg_profit_per_month >= 0 ? 'value-positive' : 'value-negative'">
          {{ supportService.formatMoney(summary.avg_profit_per_month) }}
        </div>
      </article>

      <article class="summaryCard">
        <div class="summaryLabel">Текущая прибыль за месяц</div>
        <div class="summaryValue" [ngClass]="summary.current_profit >= 0 ? 'value-positive' : 'value-negative'">
          {{ supportService.formatMoney(summary.current_profit) }}
        </div>
      </article>

      <article class="summaryCard">
        <div class="summaryLabel">Кол-во заказов за текущий месяц</div>
        <div class="summaryValue value-neutral">
          {{ summary.current_orders_count }}
        </div>
      </article>

      <article class="summaryCard debtCard">
        <div class="summaryLabel">Текущая задолженность</div>
        <div
          class="summaryValue"
          [ngClass]="summary.current_orders_debt > 0 ? 'value-negative' : 'value-positive'"
        >
          {{ supportService.formatMoney(summary.current_orders_debt) }}
        </div>
      </article>

      <article class="summaryCard">
        <div class="summaryLabel">Предоплата</div>
        <div class="summaryValue value-positive">
          {{ supportService.formatMoney(summary.current_prepayment_balance) }}
        </div>
      </article>

      <article class="summaryCard debtCard">
        <div class="summaryLabel">Просроченная задолженность</div>
        <div
          class="summaryValue"
          [ngClass]="summary.overdue_debt > 0 ? 'value-negative' : 'value-positive'"
        >
          {{ supportService.formatMoney(summary.overdue_debt) }}
        </div>
      </article>
    </div>

    <div class="analysisGrid">
      <section class="analysisCard profitCard">
        <div class="sectionHeader">
          <div><div class="sectionTitle"><mat-icon>bar_chart</mat-icon> Прибыль по месяцам</div>
            <div class="sectionSubtitle">Выручка минус себестоимость · с учётом возвратов</div></div>
        </div>
        <div class="chartScroll">
          <svg class="profitChart" viewBox="0 0 800 225" role="img" aria-label="Прибыль клиента по месяцам, грн. Точные суммы доступны в таблице ниже.">
            <g *ngFor="let tick of chart.ticks">
              <line x1="90" x2="770" [attr.y1]="tick.y" [attr.y2]="tick.y" class="chartGrid"></line>
              <text x="80" [attr.y]="tick.y + 4" text-anchor="end" class="axisLabel">{{ tick.value | number: '1.0-0' }}</text>
            </g>
            <line x1="90" x2="770" [attr.y1]="chart.zero" [attr.y2]="chart.zero" class="zeroLine"></line>
            <g *ngFor="let month of chart.bars; trackBy: trackByMonth" tabindex="0" [attr.aria-label]="chartTooltip(month)" [matTooltip]="chartTooltip(month)" matTooltipClass="client-profit-tooltip">
              <rect [attr.x]="month.x - month.width / 2" y="14" [attr.width]="month.width" height="172" fill="transparent"></rect>
              <rect [attr.x]="month.x - month.width / 2" [attr.y]="month.y" [attr.width]="month.width" [attr.height]="month.height" rx="3" [attr.fill]="month.profit < 0 ? '#cf5265' : '#159e8d'"></rect>
              <text [attr.x]="month.x" y="206" text-anchor="middle" class="axisLabel">{{ month.label }}</text>
              <circle *ngIf="month.is_current" [attr.cx]="month.x" cy="219" r="3" fill="#526de0"></circle>
            </g>
          </svg>
        </div>
        <div class="chartLegend"><span><i class="profitDot"></i> Прибыль</span><span><i class="lossDot"></i> Убыток</span><span><i class="currentDot"></i> Текущий месяц</span></div>
        <details class="monthDetails">
          <summary>Показатели по месяцам</summary>
          <div class="tableScroll">
            <table><thead><tr><th>Месяц</th><th class="numeric">Оборот</th><th class="numeric">Прибыль</th><th class="numeric">Наценка</th><th class="numeric">Заказы</th></tr></thead>
              <tbody><tr *ngFor="let month of months; trackBy: trackByMonth" [class.currentMonth]="month.is_current">
                <td>{{ month.month_label }}<small *ngIf="month.is_current">Неполный месяц</small></td>
                <td class="numeric">{{ supportService.formatMoney(month.turnover) }}</td>
                <td class="numeric" [class.value-negative]="month.profit < 0">{{ supportService.formatMoney(month.profit) }}</td>
                <td class="numeric">{{ month.markup_percent | number: '1.0-2' }}%</td><td class="numeric">{{ month.orders_count }}</td>
              </tr></tbody>
            </table>
          </div>
        </details>
      </section>
      <section class="analysisCard productsCard">
        <div class="sectionHeader"><div><div class="sectionTitle"><mat-icon>inventory_2</mat-icon> Топ товаров по прибыли</div>
          <div class="sectionSubtitle">До 10 товаров за выбранный период · количество за вычетом возвратов</div></div></div>
        <div class="tableScroll" *ngIf="report.top_products?.length; else emptyProducts">
          <table class="topProducts"><thead><tr><th>Товар / артикул</th><th class="numeric">Кол-во</th><th class="numeric">Оборот</th><th class="numeric">Прибыль</th></tr></thead>
            <tbody><tr *ngFor="let product of report.top_products; let index = index">
              <td><div class="productTitle"><span class="rank">{{ index + 1 }}</span><a [routerLink]="['/product', product.product_id]" target="_blank" rel="noopener">{{ product.product }}</a></div><small>{{ product.article || 'Без артикула' }} · №{{ product.product_id }}</small></td>
              <td class="numeric">{{ product.net_qty | number: '1.0-2' }}<small *ngIf="product.return_qty">Возврат: {{ product.return_qty | number: '1.0-2' }}</small></td>
              <td class="numeric">{{ product.turnover | number: '1.2-2' }}</td>
              <td class="numeric productProfit" [ngClass]="product.profit < 0 ? 'value-negative' : 'value-positive'">{{ product.profit | number: '1.2-2' }}</td>
            </tr></tbody>
          </table>
        </div>
        <ng-template #emptyProducts><div class="emptyState">За этот период нет закрытых продаж или возвратов с подтверждённой себестоимостью.</div></ng-template>
      </section>
    </div>
  </div>

  <ng-template #reportsState>
    <div class="stateBlock" *ngIf="loading">
      <mat-spinner [diameter]="32"></mat-spinner>
      <span>Загрузка отчета...</span>
    </div>

    <div class="stateBlock errorState" *ngIf="!loading && errorText">
      <span>{{ errorText }}</span><button mat-stroked-button (click)="reload()">Повторить</button>
    </div>

    <div class="stateBlock" *ngIf="!loading && !errorText && !report">
      <span>Выберите клиента, чтобы увидеть отчет.</span>
    </div>
  </ng-template>
</mat-card>
